<div class="bp-div container-fluid">
  <div class="container" style="min-height: 100vh">
    <router-outlet></router-outlet>
  </div>
</div>
